module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tools.currentPaneKey === 'user') ? _c('div', {
    staticClass: "pane-template sticky-header"
  }, [(!_vm.hideHeader) ? _c('pane-header', {
    attrs: {
      "title": _vm.user.title,
      "subtitle": _vm.user.sub,
      "tools": _vm.tools,
      "appIconKey": _vm.user.type,
      "hasCloseIcon": true
    }
  }) : _vm._e(), _vm._v(" "), _c('pane-content-with-sidebar', {
    attrs: {
      "updateWhenThisValueChanges": _vm.expandAll
    }
  }, [_c('pane-section', {
    attrs: {
      "id": "user-information",
      "title": "User information",
      "tools": _vm.tools,
      "hasButton": false,
      "isCollapsed": _vm.isCollapsed(false)
    }
  }, [_c('ui-link', {
    on: {
      "click": _vm.toggleExpandAll
    },
    slot: "pane-header-right"
  }, [_vm._v(_vm._s(_vm.expandAll === false ? 'Collapse all' : 'Expand all'))]), _vm._v(" "), _c('ui-details', {
    staticClass: "no-padding",
    attrs: {
      "size": "p25",
      "list": [{
          label: 'Patron group',
          value: _vm.user.patron_group,
        },
        {
          label: 'Status',
          value: _vm.user.status,
        },
        {
          label: 'Expiration date',
          value: _vm.user.expiration_date,
        },
        {
          label: 'Username',
          value: _vm.user.username,
        } ]
    }
  }), _vm._v(" "), _c('pane-section', {
    attrs: {
      "title": "Extended Information",
      "tools": _vm.tools,
      "hasButton": false,
      "isCollapsed": _vm.isCollapsed()
    }
  }), _vm._v(" "), _c('pane-section', {
    attrs: {
      "title": "Contact information",
      "tools": _vm.tools,
      "hasButton": false,
      "isCollapsed": _vm.isCollapsed()
    }
  }, [_c('skeleton-lines', {
    attrs: {
      "lines": 4
    }
  })], 1), _vm._v(" "), _c('pane-section', {
    attrs: {
      "title": "Addresses",
      "tools": _vm.tools,
      "hasButton": false,
      "isCollapsed": _vm.isCollapsed()
    }
  }, [_c('skeleton-lines', {
    attrs: {
      "lines": 3
    }
  })], 1)], 1), _vm._v(" "), _c('pane-section', {
    attrs: {
      "id": "proxy",
      "title": "Proxy",
      "tools": _vm.tools,
      "hasButton": false,
      "isCollapsed": _vm.isCollapsed()
    }
  }, [_c('skeleton-lines', {
    attrs: {
      "lines": 20
    }
  })], 1), _vm._v(" "), _c('pane-section', {
    attrs: {
      "id": "fees-and-fines",
      "title": "Fees and fines",
      "itemCountMax": 4,
      "itemCountMin": 2,
      "preset": "fee",
      "includeInList": {
        user: _vm.user
      },
      "tools": _vm.tools,
      "hasButton": false,
      "isCollapsed": _vm.isCollapsed()
    }
  }, [_c('ui-button', {
    on: {
      "click": _vm.viewUserFees
    },
    slot: "pane-header-right"
  }, [_vm._v("View history")])], 1), _vm._v(" "), _c('pane-section', {
    attrs: {
      "id": "loans",
      "hasButton": false,
      "title": "Loans",
      "tools": _vm.tools,
      "isCollapsed": _vm.isCollapsed(false),
      "includeInList": {
        user: _vm.user
      }
    }
  }, [_c('ui-button', {
    on: {
      "click": _vm.viewUserLoans
    },
    slot: "pane-header-right"
  }, [_vm._v("View Loans")]), _vm._v(" "), _c('ui-link', {
    on: {
      "click": _vm.viewUserLoans
    }
  }, [_vm._v("Open loans")]), _c('br'), _vm._v(" "), _c('ui-link', {
    on: {
      "click": _vm.viewUserLoans
    }
  }, [_vm._v("Closed loans")])], 1), _vm._v(" "), _c('pane-section', {
    attrs: {
      "id": "communications",
      "title": "Communications",
      "tools": _vm.tools,
      "hasButton": false,
      "isCollapsed": _vm.isCollapsed()
    }
  }, [_c('skeleton-lines', {
    attrs: {
      "lines": 20
    }
  })], 1), _vm._v(" "), _c('pane-section', {
    attrs: {
      "id": "patron-groups",
      "title": "Patron groups",
      "tools": _vm.tools,
      "hasButton": false,
      "isCollapsed": _vm.isCollapsed()
    }
  }, [_c('skeleton-lines', {
    attrs: {
      "lines": 20
    }
  })], 1), _vm._v(" "), _c('pane-section', {
    attrs: {
      "id": "staff-permissions",
      "title": "Staff permissions",
      "tools": _vm.tools,
      "hasButton": false,
      "isCollapsed": _vm.isCollapsed()
    }
  }, [_c('ui-button', {
    slot: "pane-header-right"
  }, [_vm._v("Add permission")]), _vm._v(" "), _c('skeleton-lines', {
    attrs: {
      "lines": 20
    }
  })], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a14502ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pane-templates/UserPaneTemplate.vue
// module id = 462
// module chunks = 1